// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

@Pipe({
    name: 'hasDomainAccess',
    standalone: false,
})
export class HasDomainAccessPipe implements PipeTransform {
    constructor (private sessionService: SessionService) {}

    transform (domain: any): boolean {
        if (!this.sessionService.me || (domain && typeof domain === 'object' && !domain.id)) {
            return false;
        }

        if (this.sessionService.hasRole('customer_admin')) {
            return true;
        }

        let hasAccess = false;
        const agreement = this.sessionService.agreement;

        if (this.sessionService.me && agreement && Array.isArray(agreement.domain_users)) {
            for (let i = 0; i < agreement.domain_users.length; i++) {
                const domainUser = agreement.domain_users[i];
                if (domainUser && domainUser.domain_id === domain?.id) {
                    if (domainUser.visible === true) {
                        hasAccess = true;
                    }
                }
            }
        }

        return hasAccess;
    }
}
